/* eslint-disable css-modules/no-unused-class  */
import { useState, FC, useEffect } from 'react';
import { translate } from 'translations';
import { Icon, AccordionTable, CollapseTableData, Avatar } from 'learning-panel-components';
import classNames from 'classnames';
import styles from './userLeaderboard.module.scss';

const getClassName = (baseClass: string, index: number) =>
    classNames(styles[baseClass], { [styles['first-row']]: index === 0 });

export const getRow = (
    row: UserData,
    index: number,
    currentUserNickname: string,
    youText: string,
    showTeamsNames?: boolean,
    addTeamElement?: boolean
) => {
    const iconElement = (
        <div key={`${index}-icon`} className={styles['rank-wrapper']}>
            {`#${row.rank}`}
        </div>
    );
    const nameElement = (
        <div key={`${index}-name`} className={getClassName('row-name', index)}>
            {addTeamElement ? (
                <Avatar name={row.nickname} avatarSrc={row.profilePicture} size="1.7rem" />
            ) : (
                <img
                    className={styles.avatar}
                    src={`${process.env.PUBLIC_URL}/images/avatars/tournaments/${row.avatar}.svg`}
                    alt="avatar"
                />
            )}
            <div title={row.nickname} className={styles.text}>
                {row.nickname === currentUserNickname ? youText : row.nickname}
            </div>
        </div>
    );

    let teamNamesElement = null;
    if (addTeamElement) {
        teamNamesElement = (
            <div key={`${index}-team`} title={row.teams} className={getClassName('row-teams', index)}>
                {row.teams}
            </div>
        );
    }

    const scoreElement = (
        <div key={`${index}-score`} className={styles['row-score']}>
            <Icon name="devCoin" className={styles['dev-coin']} />
            <div>{row.score.toLocaleString()}</div>
        </div>
    );
    const rowDivs = [iconElement, nameElement, scoreElement];
    teamNamesElement && showTeamsNames && rowDivs.splice(2, 0, teamNamesElement);
    return rowDivs;
};

const UserLeaderboard: FC<UserLeaderboardProps> = (props: UserLeaderboardProps) => {
    const {
        currentUser,
        users,
        onLoadMore,
        hasMore,
        tableHeight = '32rem',
        currentUserTop = '6.5rem',
        showTeamsNames,
        isTournament
    } = props;
    const youText = translate('You');

    const [rows, setRows] = useState<CollapseTableData[]>([]);

    useEffect(() => {
        const tmpRows: CollapseTableData[] = users?.map((user: UserData, i: number) => ({
            row: getRow(user, i, currentUser.nickname, youText, showTeamsNames, !isTournament)
        }));
        setRows(tmpRows);
    }, [users]);

    return (
        <>
            <div style={{ '--currentUserTop': currentUserTop } as any} className={styles['full-expand-current-user']}>
                {getRow(currentUser, -1, currentUser.nickname, youText, showTeamsNames, !isTournament)}
            </div>
            {rows.length > 0 && (
                <AccordionTable
                    rows={rows}
                    title=""
                    isOpen={true}
                    hasMoreRows={hasMore}
                    loadMoreRows={onLoadMore}
                    showTitle={false}
                    tableHeight={tableHeight}
                />
            )}
        </>
    );
};

interface UserLeaderboardProps {
    currentUser: UserData;
    users: UserData[];
    onLoadMore: Function;
    hasMore: boolean;
    tableHeight?: string;
    currentUserTop?: string;
    showTeamsNames?: boolean;
    isTournament: boolean;
}

export interface UserData {
    rank: number;
    nickname: string;
    score: number;
    profilePicture?: string;
    avatar?: string;
    teams?: string;
}

export default UserLeaderboard;
